import { render, staticRenderFns } from "./audio-upload.vue?vue&type=template&id=59cce3c6&"
import script from "./audio-upload.vue?vue&type=script&lang=js&"
export * from "./audio-upload.vue?vue&type=script&lang=js&"
import style0 from "./audio-upload.vue?vue&type=style&index=0&id=59cce3c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports